var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXeuBlueArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 14L-2.62268e-07 13L-8.74228e-08 11L21 10L21 14Z",
    fill: "#02235B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2L23.4143 11.9999L13 22L10 22L19 11.9999L10 2L13 2Z",
    fill: "#02235B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXeuBlueArrowRight);
export default __webpack_public_path__ + "static/media/xeu-blue-arrow-right.f81e7b8e8f8b48cb5f29f72826d7f281.svg";
export { ForwardRef as ReactComponent };